import { useTranslation } from 'react-i18next';

import type { BrandApplicationCounts } from '@nucleus-commerce/api-client/platform';
import { Tabs, TabsList, TabsTrigger } from '@nucleus-commerce/ui/components/tabs';

import { STATUS_TABS, type StatusTab } from '../schemas/application-rules';

export interface ApplicationStatusTabsProps {
  value: StatusTab;
  counts: BrandApplicationCounts | undefined;
  onChange: (tab: StatusTab) => void;
}

const isTab = (value: string): value is StatusTab =>
  (STATUS_TABS as readonly string[]).includes(value);

/** One tab per status with its count; the counts ignore the search, like the backend's. */
export function ApplicationStatusTabs({ value, counts, onChange }: ApplicationStatusTabsProps) {
  const { t } = useTranslation('applications');
  return (
    <Tabs value={value} onValueChange={(next) => isTab(next) && onChange(next)}>
      <TabsList
        className="h-auto flex-wrap justify-start"
        aria-label={t('tabs.label')}
        data-tour="platform.applications.tabs"
      >
        {STATUS_TABS.map((tab) => (
          <TabsTrigger key={tab} value={tab} className="gap-1.5">
            {t(`tabs.${tab}`)}
            {counts ? (
              <span className="text-muted-foreground text-xs tabular-nums">{counts[tab]}</span>
            ) : null}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
